import type { WizardAnswers } from '@/context/WizardSessionContext';

/** API / Prisma nested shape for answers_json */
export type ApiAnswers = {
  venture?: {
    venture_type?: string;
    required_area_sqm?: number;
    timeline?: string;
  };
  parcel?: {
    migrash?: string;
    gush?: string;
    helka?: string;
    lat?: number;
    lng?: number;
    settlement_name?: string;
    designation?: string;
    plan_primary?: string;
    area_sqm_registered?: number;
    geometry?: { type: string; coordinates: unknown };
    selection_mode?: 'point' | 'polygon_drawn';
    area_sqm_drawn?: number;
  };
  contact?: {
    full_name?: string;
    phone?: string;
    email?: string;
  };
};

export function answersToApi(flat: WizardAnswers): ApiAnswers {
  const api: ApiAnswers = {};
  if (
    flat.venture_type != null ||
    flat.required_area_sqm != null ||
    flat.timeline != null
  ) {
    api.venture = {
      venture_type: flat.venture_type,
      required_area_sqm: flat.required_area_sqm,
      timeline: flat.timeline,
    };
  }
  if (
    flat.migrash != null ||
    flat.gush != null ||
    flat.helka != null ||
    flat.map_lat != null ||
    flat.map_lng != null ||
    flat.settlement_name != null ||
    flat.designation != null ||
    flat.parcel_geometry != null ||
    flat.selection_mode != null
  ) {
    api.parcel = {
      migrash: flat.migrash,
      gush: flat.gush,
      helka: flat.helka,
      lat: flat.map_lat,
      lng: flat.map_lng,
      settlement_name: flat.settlement_name,
      designation: flat.designation,
      plan_primary: flat.plan_primary,
      area_sqm_registered: flat.area_sqm_registered,
      geometry: flat.parcel_geometry,
      selection_mode: flat.selection_mode,
      area_sqm_drawn: flat.area_sqm_drawn,
    };
  }
  if (
    flat.contact_name != null ||
    flat.contact_phone != null ||
    flat.contact_email != null
  ) {
    api.contact = {
      full_name: flat.contact_name,
      phone: flat.contact_phone,
      email: flat.contact_email,
    };
  }
  return api;
}

export function answersFromApi(raw: Record<string, unknown> | ApiAnswers): WizardAnswers {
  const venture =
    raw.venture != null && typeof raw.venture === 'object'
      ? (raw.venture as ApiAnswers['venture'])
      : undefined;
  const parcel =
    raw.parcel != null && typeof raw.parcel === 'object'
      ? (raw.parcel as ApiAnswers['parcel'])
      : undefined;
  const contact =
    raw.contact != null && typeof raw.contact === 'object'
      ? (raw.contact as ApiAnswers['contact'])
      : undefined;

  if (venture || parcel || contact) {
    return {
      venture_type: venture?.venture_type,
      required_area_sqm: venture?.required_area_sqm,
      timeline: venture?.timeline,
      migrash: parcel?.migrash,
      gush: parcel?.gush,
      helka: parcel?.helka,
      settlement_name: parcel?.settlement_name,
      designation: parcel?.designation,
      plan_primary: parcel?.plan_primary,
      area_sqm_registered: parcel?.area_sqm_registered,
      parcel_geometry: parcel?.geometry,
      selection_mode: parcel?.selection_mode,
      area_sqm_drawn: parcel?.area_sqm_drawn,
      map_lat: parcel?.lat,
      map_lng: parcel?.lng,
      contact_name: contact?.full_name,
      contact_phone: contact?.phone,
      contact_email: contact?.email,
    };
  }

  return raw as WizardAnswers;
}
